module.exports = __webpack_public_path__ + "static/media/ticket-bg.a94a813c.jpg";